export type TealiumEnvironment = 'dev' | 'qa' | 'prod';

export const toValidTealiumEnvironment = (
  potentialEnvironment: unknown,
  fallbackEnvironment: TealiumEnvironment = 'prod',
): TealiumEnvironment => {
  if (
    potentialEnvironment === 'dev' ||
    potentialEnvironment === 'qa' ||
    potentialEnvironment === 'prod'
  ) {
    return potentialEnvironment;
  }

  return fallbackEnvironment;
};
